import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import DeletePopup from "../GardenPopup/DeletePopup"
import ContractorNamePopup from "./ContractorNamePopup"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { ContractorNameDeleteAPI, ContractorNameTableDataAPI } from "../../../../Redux/SidebarMasterSlice/ContractorNameSlice"
import { Loading } from "../../../../Helper/Loading"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { useSearchParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { WorkTypeDDL } from "../../../../Components/CommonDDL/WorkTypeDDL"
import { ContractorWiseAssetDDL } from "../../../../Components/CommonDDL/WorkTypeWiseContractorDDL"
import { ContactPersonDDL } from "../../../../Components/CommonDDL/ContactPersonDDL"
import { ContractorNameDDL } from "../../../../Components/CommonDDL/ContractorNameDDL"

export const ContractorName = () => {

    const { t } = useTranslation()

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let Lang = searchParams.get("Lang")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [IsSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [DepartmentPopupShow, setDepartmentPopupShow] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [ContractorNamePopupShow, setContractorNamePopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setContractorNamePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setContractorNamePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setContractorNamePopupShow(false)
    }

    const [ContractorWiseAsset, setContractorWiseAsset] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ContactPersonName, setContactPersonName] = useState({
        DDL: [],
        ID: 0,
        m_UserID: 0,
        Label: "Select...",
    })
    const [ZoneNameDDLID, setZoneNameDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })
    const [ContractorName, setContractorName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [AssetType, setAssetType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: ''
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])

    const handleDeleteOnClick = () => {
        console.log("delete")
        setDeletePopupShow(true)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [ContractorWiseAsset.ID])

    const handleDeleteApi = (item) => {
        const data = {
            M_ContractorID: item.m_ContractorID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(ContractorNameDeleteAPI({ data }))
    }

    const handleClear = () => {
        setFrom(1)
        setTo(10)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setContractorWiseAsset({
            ...ContractorWiseAsset,
            ID: 0,
            Label: 'Select...'
        })
        setWorkType({
            ...WorkType,
            ID: 0,
            Label: 'Select...'
        })
        setContactPersonName({
            ...ContactPersonName,
            ID: 0,
            Label: 'Select...'
        })
        setContractorName({
            ...ContractorName,
            ID: 0,
            Label: 'Select...'
        })
    }

    useEffect(() => {
        const data = {
            // M_ContractorID: ContractorWiseAsset.ID,
            M_ContractorID: ContractorWiseAsset.ID,
            ContractorName: '',
            M_WorkTypeID: WorkType.ID,
            M_UsersID: ContactPersonName.m_UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(ContractorNameTableDataAPI({ data }))
    }, [IsPost, ContractorWiseAsset.ID, WorkType.ID, To, IsClear])

    const { tableData, isLoading } = useSelector(state => state.ContractorNameTableData)


    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                    Language={Language}
                    setLanguage={setLanguage}
                />
                <div className="wrapper p-3">
                    <Sidebar
                        Language={Language}
                        ProjectTypeId={ProjectTypeId} />
                    <div id="" className="content1">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div>
                                    <h5 className="ps-1 py-2 ">{t('AdminDashboard.Admin_Sidebar_Grid_Heading.Contractor_Name_Master')}</h5>
                                    <div className="col-12 col-lg-7 float-end">
                                        <i className="fa-solid fa-plus btn btn-secondary mb-2 float-end" onClick={handleAddOnClick} style={{ color: "white", marginTop: '-2.5em' }}>
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12 ">

                                            <div className="row rounded2 d-flex align-items-end">

                                                <div className="col-12 col-md-5 col-lg-3">
                                                    <WorkTypeDDL
                                                        WorkType={WorkType}
                                                        setWorkType={setWorkType}
                                                        IsPost={IsPost}
                                                        Language={Language}
                                                        Flag1='ProjectType'
                                                    />
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <ContractorWiseAssetDDL
                                                        ContractorWiseAsset={ContractorWiseAsset}
                                                        setContractorWiseAsset={setContractorWiseAsset}
                                                        rowData={rowData}
                                                        WorkType={WorkType}
                                                        AssetType={AssetType}
                                                        WardWiseAssetName={0}
                                                        RoleID={RoleID}
                                                        Flag='Master'
                                                        Language={Language}
                                                        Flag1='ContractorName'
                                                        ZoneNameDDLID={ZoneNameDDLID}

                                                    />
                                                </div>
                                                {/* <div className="col-12 col-md-6 col-lg-3">
                                                    <ContractorNameDDL
                                                        ContractorName={ContractorName}
                                                        setContractorName={setContractorName}
                                                        IsPost={IsPost}
                                                        Language={Language}
                                                        Flag='Master'
                                                    />
                                                </div> */}
                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <ContactPersonDDL
                                                        ContactPersonName={ContactPersonName}
                                                        setContactPersonName={setContactPersonName}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-2 col-lg-2 pb-2" >
                                                    <button type="button" className="btn-clear btn btn-primary"
                                                        onClick={handleClear}
                                                    >Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Project Type</th>
                                                            <th>Contractor Name</th>
                                                            <th>Address</th>
                                                            <th>Contact Person Name</th>
                                                            <th>Mobile Number</th>
                                                            <th>Email Id</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                    <td>{item.workTypeName ? item.workTypeName : '-'}</td>
                                                                    <td>{item.contractorName ? item.contractorName : '-'}</td>
                                                                    <td>{item.address ? item.address : '-'}</td>
                                                                    <td>{item.loginM_UserName ? item.loginM_UserName : '-'}</td>
                                                                    <td>{item.mobileNo ? item.mobileNo : '-'}</td>
                                                                    <td>{item.emailID ? item.emailID : '-'}</td>

                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <></>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    IsClear={IsClear}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    ContractorNamePopupShow ?
                        <ContractorNamePopup
                            open={ContractorNamePopupShow}
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </>
    )
}